export default "__VITE_ASSET__B5Ng90X0__"